module.exports = __webpack_public_path__ + "img/hr-green-croton-12.65d10f10.png";